import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=d3f3bc94&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=d3f3bc94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f3bc94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3f3bc94')) {
      api.createRecord('d3f3bc94', component.options)
    } else {
      api.reload('d3f3bc94', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=d3f3bc94&scoped=true&", function () {
      api.rerender('d3f3bc94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UuS2KR37x3xe/JS/comp/CookieBox.vue"
export default component.exports